<!-- Translated: skip -->
<template>
  <div class="component">
    <div class="flex" v-if="localResetPasswordSuccessMessage">
      <div class="info">
        <p>{{localResetPasswordSuccessMessage}}</p>
      </div>
    </div>
    <div>
    </div>
    <div class="flex" v-if="!loggedIn && !$route.query.admin">
      <div>
        <b>E-postadress</b>
        <input type="email" v-model="email" @keyup.enter="login" />
      </div>
      <div>
        <b>Lösenord</b>
        <input type="password" @keyup.enter="login" v-model="password" />
      </div>
      <div v-if="error">
        <p class="error-message">
          Uppgifterna stämde inte. Försök igen med ett annat lösenord eller beställ ett nytt lösenord nedan.</p>
      </div>
      <div class="center">
        <p class="spacer">&nbsp;</p>
        <button class="small" :disabled="loading" @click="login()">{{loading ? 'Loggar in...' : 'Logga in'}}</button>
      </div>
      <div class="center">
        <p class="spacer">&nbsp;</p>
        <router-link class="button white small underlined" :to="{ name: 'request reset password' }">Glömt lösenord</router-link>
        <router-link class="button white small underlined" :to="{ name: 'request new password' }">Har inget lösenord</router-link>
      </div>
    </div>

    <!-- Admin Login Section -->
    <div class="flex" v-if="$route.query.admin && !adminUser">
      <!-- Microsoft SSO -->
      <div v-if="microsoftSsoEnabled" class="center ms-login-container">
        <h3>Administrationsinloggning</h3>
        <p class="ms-info-text">Logga in säkert med ditt Microsoft-konto.</p>
        
        <div v-if="ssoError" class="error-box">
          <p class="error-message">{{ getErrorMessage(ssoError) }}</p>
        </div>

        <button class="ms-btn" @click="loginWithMicrosoft()">
          <span class="ms-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="20" height="20">
              <path fill="#f35325" d="M0 0h11v11H0z"/>
              <path fill="#81bc06" d="M12 0h11v11H12z"/>
              <path fill="#05a6f0" d="M0 12h11v11H0z"/>
              <path fill="#ffba08" d="M12 12h11v11H12z"/>
            </svg>
          </span>
          Logga in med Microsoft
        </button>
      </div>

      <!-- Magic Link fallback -->
      <div v-else>
        <div v-if="successMessage" class="success-box">
          <p class="success-message">{{ successMessage }}</p>
        </div>
        <div v-else>
          <div>
            <b>E-postadress för admin</b>
            <input type="email" v-model="email" @keyup.enter="sendMagicLink" style="margin-bottom:15px;" />
          </div>

          <!-- Altcha Widget -->
          <div style="margin: 15px 0; max-width: 260px;">
            <altcha-widget
              :challengeurl="altchaUrl"
              hideLogo
              @statechange="onAltchaChange"
            ></altcha-widget>
          </div>

          <div v-if="error">
            <p class="error-message">{{ errorMessage || 'Uppgifterna stämde inte. Försök igen.' }}</p>
          </div>
          <div class="center" style="margin-top: 15px;">
            <p class="spacer">&nbsp;</p>
            <button class="small" :disabled="loading || !altchaVerified" @click="sendMagicLink()">
              {{ loading ? 'Skickar...' : 'Skicka inloggningslänk' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="adminUser || $route.query.admin">
      <hr />
    </div>

    <div class="flex" v-if="adminUser">
      <div>
        <div class="center">
          <button class="small" @click="goToAdmin()">Gå till admin</button>
          <br /><br /><br /><br />
        </div>
      </div>
      <div>
        <p>Du är inloggad i admin</p>
        <div class="center">
          <button class="small white" @click="logoutAdmin()">Logga ut från admin</button>
        </div>
      </div>
    </div>

    <div class="flex" v-if="loggedIn">
      <div>
        <p>Du är inloggad</p>
        <div class="center">
          <button class="small" @click="logout()">Logga ut</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import API from '@/classes/API';

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      email: '',
      password: '',
      passwordShow: true,
      loading: false,
      error: false,
      errorMessage: '',
      successMessage: '',
      localResetPasswordSuccessMessage: '',
      altchaVerified: false,
      altchaValue: '',
    };
  },
  mounted() {
    this.localResetPasswordSuccessMessage = this.resetPasswordSuccessMessage;
    this.updateResetPasswordSuccessMessage('');

    // Load Altcha Widget dynamically
    if (!this.microsoftSsoEnabled && !document.getElementById('altcha-script')) {
      const script = document.createElement('script');
      script.id = 'altcha-script';
      script.type = 'module';
      script.src = 'https://cdn.jsdelivr.net/npm/altcha/dist/altcha.min.js';
      script.defer = true;
      document.head.appendChild(script);
    }
  },
  updated() {
    this.updateResetPasswordSuccessMessage('');
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'resetPasswordSuccessMessage',
    ]),
    adminUser() {
      // Check if standard admin user is set in state
      return this.$store.state.user && this.$store.state.user.isAdmin;
    },
    ssoError() {
      return this.$route.query.error || '';
    },
    microsoftSsoEnabled() {
      return window.SITE_CONFIG && window.SITE_CONFIG.microsoft_sso_enabled !== false;
    },
    altchaUrl() {
      return API.getUrl('/altcha');
    },
  },
  methods: {
    ...mapMutations([
      'setUser',
      'updateResetPasswordSuccessMessage',
    ]),
    onAltchaChange(event) {
      console.log('onAltchaChange event detail:', event.detail);
      const { state, payload } = event.detail;
      if (state === 'verified') {
        this.altchaVerified = true;
        this.altchaValue = payload;
      } else {
        this.altchaVerified = false;
        this.altchaValue = null;
      }
    },
    async sendMagicLink() {
      if (!this.email) {
        this.error = true;
        this.errorMessage = 'E-postadress krävs.';
        return;
      }

      let altchaValue = this.altchaValue;
      if (!altchaValue) {
        const altchaWidget = document.querySelector('altcha-widget');
        if (altchaWidget) {
          const input = altchaWidget.querySelector('input[name="altcha"]');
          if (input && input.value) {
            altchaValue = input.value;
          }
        }
      }

      if (!altchaValue) {
        this.error = true;
        this.errorMessage = 'Säkerhetskontrollen måste slutföras.';
        return;
      }

      this.loading = true;
      this.error = false;
      this.errorMessage = '';
      try {
        const response = await API.post('/account/magic-login', {
          email: this.email,
          altcha: altchaValue,
        });
        if (response.success) {
          this.successMessage = response.successMessage;
        } else {
          this.error = true;
          this.errorMessage = response.errorMessage || 'Kunde inte skicka länk.';
        }
      } catch (err) {
        this.error = true;
        this.errorMessage = err.response && err.response.data && err.response.data.errorMessage
          ? err.response.data.errorMessage
          : 'Kunde inte skicka inloggningslänk. Kontrollera e-postadressen.';
      } finally {
        this.loading = false;
      }
    },
    loginWithMicrosoft() {
      window.location.href = API.getUrl('/admin/auth/microsoft');
    },
    getErrorMessage(errorCode) {
      const errors = {
        generic: 'Inloggningen misslyckades. Kontrollera dina uppgifter och försök igen.',
        session_expired: 'Din session har gått ut på grund av inaktivitet. Vänligen logga in igen.',
      };
      return errors[errorCode] || 'Inloggningen misslyckades. Kontrollera dina uppgifter och försök igen.';
    },
    async login() {
      this.loading = true;
      try {
        const { success, token, user, isAdmin } = await API.post('/account/authenticate', {
          email: this.email,
          password: this.password,
        });

        if (success) {
          this.$store.state.user = user;
          this.$store.state.user.isAdmin = isAdmin;
          this.$store.state.user.token = token;

          this.setUser({
            token,
          });

          this.$emit('login', success);

          document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));
        } else {
          this.error = true;
        }
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    async logout() {
      this.loading = true;
      const success = await API.get('/account/deauthenticate');
      this.setUser({
        token: null,
      });
      if (success) {
        this.$emit('logout', success);

        document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));
      }
      this.loading = false;
    },
    async logoutAdmin() {
      this.loading = true;
      await API.get('/admin/logout');
      this.$store.state.user = {};
      this.$emit('logout', true);
      this.loading = false;
    },
    goToAdmin() {
      this.$router.push('/admin');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.info
  info-box()
  max-width 400px
  margin-bottom 20px

.component
  text-align: center

b
  display block
  uppercase()
  margin-top 10px

p.spacer
  margin-bottom 0
  margin-top 0
  font-size 10px

.flex
  //display flex
  display inline-block
  text-align left

.error-message
  max-width 260px
  margin-top 10px
  margin-bottom 0
  color: red
  font-weight: 500

.error-box
  max-width: 320px
  padding: 10px 15px
  background-color: #fce8e6
  border: 1px solid #f8c3cd
  border-radius: 4px
  margin-bottom: 20px

.success-message
  max-width 260px
  margin-top 10px
  margin-bottom 0
  color: green
  font-weight: 500

.success-box
  max-width: 300px
  padding: 15px
  background-color: #e6f7ed
  border: 1px solid #cce8d5
  border-radius: 4px

.ms-login-container
  max-width 360px
  padding: 20px
  border: 1px solid #eaeaea
  border-radius: 6px
  background-color: #fafafa
  h3
    margin-bottom 10px
    font-size 1.25rem
  .ms-info-text
    font-size 0.9rem
    color #666
    margin-bottom 20px

.ms-btn
  display inline-flex
  align-items center
  justify-content center
  background-color #2f2f2f
  color white
  font-weight 600
  font-size 0.95rem
  padding 10px 18px
  border-radius 4px
  border none
  cursor pointer
  transition background-color 0.2s
  width 100%
  &:hover
    background-color #1f1f1f
  .ms-icon
    margin-right 10px
    display flex
    align-items center

input
  input()
  min-width 260px
  max-width 260px
</style>



// WEBPACK FOOTER //
// Login.vue?4a3853de